import { Divider, Flex, VStack,Text } from '@chakra-ui/react'
import { useState } from 'react'
import { BsPen } from 'react-icons/bs'
import ContractSearchPanel from '../components/adminContract/ContractSearchPanel'
import TableAllContracts from '../components/adminContract/TableAllContracts'
import { BlockContainer, BlockContent, BlockHeader } from '../components/shared/Block'
import SearchQueryContext from '../context/searchQueryContext'

const AdminContract = () => {
  const [query, setQuery] = useState("")

  return (
    <Flex p="40px" direction="column" w="full">
    <SearchQueryContext.Provider value={[query, setQuery]}>
        <BlockContainer>
            <BlockHeader title="รายการการทำสัญญาเข้าพักอาศัย" icon={BsPen}/>
            <Divider />
            <BlockContent mt={6}>
                <VStack w="full" spacing={8}>
                    <ContractSearchPanel />
                    <Text fontWeight="bold">ผลลัพธ์การค้นหา</Text>
                    <TableAllContracts />
                </VStack>
            </BlockContent>
        </BlockContainer>
    </SearchQueryContext.Provider >
</Flex>
  )
}

export default AdminContract